import React from 'react'

const DocmHelp = () => (
  <p>Por razões de segurança, não aceitamos documentos do Word contendo macros.</p>
)

export default DocmHelp
